import './checkbox.css';
import * as cn from 'classnames';
import { ReactComponent as CheckIcon } from '../../../assets/check.svg';
import tinycolor from 'tinycolor2';

export const Checkbox = ({ checked, color, onClick, children }) => {
  return (
    <div className={cn('checkbox-container', checked ? 'checked' : '')} onClick={onClick}>
      {/* <div className="checkbox-check-container" style={{ borderColor: color || '', backgroundColor: (color && tinycolor(color).lighten(20)) || '' }}> */}
      <div className="checkbox-check-container" style={{ borderColor: color || '', backgroundColor: color || '' }}>
        {checked && <CheckIcon className="check-icon" />}
      </div>
      <div className="checkbox-label">{children}</div>
    </div>
  );
};
